import {
    CONTACT_OPTIONS_WHATSAPP_KEY,
    CONTACT_OPTIONS_SIGNAL_KEY,
    CONTACT_OPTIONS_TELEGRAM_KEY,
    CONTACT_OPTIONS_THREEMA_KEY,
} from '../../../contactOptions-config';

export const contactViaActionUrl = (preference, rawPhone) => {
    const cleanPhone = rawPhone.replace(/\D/g, '');
    const formattedPhone = `+${cleanPhone}`;

    switch (preference) {
        case CONTACT_OPTIONS_WHATSAPP_KEY:
            window.open(`https://wa.me/${formattedPhone}`, '_blank', 'noopener,noreferrer');
            break;

        case CONTACT_OPTIONS_TELEGRAM_KEY:
            window.open(`https://t.me/${formattedPhone}`, '_blank', 'noopener,noreferrer');
            break;

        case CONTACT_OPTIONS_SIGNAL_KEY:
            window.open(`https://signal.me/#p/${formattedPhone}`, '_blank', 'noopener,noreferrer');
            break;

        case CONTACT_OPTIONS_THREEMA_KEY: {
            const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
            if (isMobile) {
                window.location.href = `threema://compose?phone=${cleanPhone}`;
            } else {
                navigator.clipboard.writeText(cleanPhone);
                window.open('https://web.threema.ch/', '_blank', 'noopener,noreferrer');
            }
            break;
        }

        default:
            window.open(`tel:+${cleanPhone}`, '_blank', 'noopener,noreferrer');
    }
};
